/**
 * Typed Redux Hooks
 *
 * Use these hooks instead of plain useDispatch and useSelector
 * for proper TypeScript type inference.
 */

import { useDispatch, useSelector, type TypedUseSelectorHook } from '@spcc/core'
import type { RootState, AppDispatch } from './index'

// Typed dispatch hook
export const useAppDispatch: () => AppDispatch = useDispatch

// Typed selector hook
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
